/**
 * created by li si yi
 * 密码配置
 */
import React, {Component} from 'react';
import {Button, Select, InputNumber, message, Switch} from "antd";
import './PasswordConfiguration.css'
import BaseComponent from "../../../base/BaseComponent";
import SpacerBlock from "../../components/spacerBlock/SpacerBlock";

// 表格数据
const tableList = [
    {
        title: '简单',
        content: '密码在长度范围内即可（密码的长度范围为7至20个字符）'
    },
    {
        title: '标准',
        content: '至少包含2种字符格式'
    },
    {
        title: '复杂',
        content: '至少包含3种字符格式'
    }
];
const {Option} = Select;

export default class PasswordConfiguration extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            // 当前级别
            currentLevel: "",
            // 保存
            saveLevel: '',
            // 密码过期时间
            updatePwdTime: '',
            firstUpdate: false,
            outTimeUpdate: false,
            pwdResetUpdate: false
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getPwdConfig();
    }

    componentWillUnmount() {
    }

    // 密码更换策略保存
    save() {
        this.updatePwdConfig();
    }

    // 密码强度等级改变
    onChange = (value) => {
        this.setState({
            currentLevel: value,
        })
    };

    render() {
        return (
            <div style={{
                backgroundColor: '#fff',
                marginTop: '15px',
                padding: '25px 30px',
                maxHeight: "calc(100vh - 100px)",
                marginLeft: '15px',
                borderRadius: '5px'
            }}>
                {/*表格*/}
                {this.renderTable()}
                {/*字符格式*/}
                {this.renderCharFormat()}
                {/*密码更换策略*/}
                {this.renderPasswordTactics()}
            </div>
        )
    }

    // 表格
    renderTable = () => {
        let {currentLevel} = this.state;
        return (
            <div>
                <div className={'passwordLevel'}>密码强度级别</div>
                <div>
                    <span className={'passwordLevel'} style={{fontWeight: '400'}}>密码强度等级：</span>
                    <Select
                        style={{width: 225}}
                        value={currentLevel}
                        optionFilterProp="children"
                        onChange={this.onChange}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        <Option value="0">简单</Option>
                        <Option value="1">标准</Option>
                        <Option value="2">复杂</Option>
                    </Select>
                </div>
                <table className={'tableContent'}>
                    <tbody>
                    {
                        tableList.map((item) => {
                            return (
                                <tr key={item.title}>
                                    <td className={'borderSty'} style={{width: 120}}>{item.title}</td>
                                    <td className={'borderSty'} style={{width: 730}}>{item.content}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    };
    // 字符格式
    renderCharFormat = () => {
        return (
            <div>
                <div className={'passwordLevel'} style={{margin: '23px 0 15px 0', fontWeight: '400'}}>四种字符格式：</div>
                <div style={{lineHeight: '22px'}}>
                    大写字母（A-Z）<br/>
                    小写字母（a-z）<br/>
                    数字（0-9）<br/>
                    特殊字符（非数字、字母、中文字符，例如：！、@、#等）
                </div>
            </div>
        )
    };
    // 开关
    switchOnChange = (e, name) => {
        this.state[name] = e;
        this.setState({})
    };
    // 密码更换策略
    renderPasswordTactics = () => {
        return (
            <div style={{marginTop: 23, display: 'flex', flexDirection: 'column'}}>
                <div style={{background: '#ffffff'}}>
                    <SpacerBlock height={1}/>
                    <div style={{lineHeight: '19px', fontSize: 14, margin: '15px 0'}}
                         className={'passwordLevel'}>密码更换策略
                    </div>
                    <div style={{color: '#000', marginBottom: 15, display: 'flex', alignItems: 'center'}}>
                        <Switch checkedChildren="开" unCheckedChildren="关" checked={this.state.outTimeUpdate}
                                style={{marginRight: 15}} onChange={(e) => this.switchOnChange(e, 'outTimeUpdate')}/>
                        <InputNumber max={99999} style={{marginRight: 5}} min={1} value={this.state.updatePwdTime}
                                     maxLength={5}
                                     precision={0}
                                     disabled={!this.state.outTimeUpdate}
                                     parser={value => value.replace(/\D/g, '')}
                                     onChange={(value) => {
                                         if (!value) {
                                             this.setState({updatePwdTime: 99999})
                                         } else {
                                             this.setState({updatePwdTime: value})
                                         }
                                     }}
                        />
                        天强制更换密码。
                    </div>
                    <div style={{color: '#000', marginBottom: 15, display: 'flex', alignItems: 'center'}}>
                        <Switch checkedChildren="开" unCheckedChildren="关" checked={this.state.firstUpdate}
                                style={{marginRight: 15}} onChange={(e) => this.switchOnChange(e, 'firstUpdate')}/>
                        用户首次登录需要修改密码
                    </div>
                    <div style={{color: '#000', marginBottom: 15, display: 'flex', alignItems: 'center'}}>
                        <Switch checkedChildren="开" unCheckedChildren="关" checked={this.state.pwdResetUpdate}
                                style={{marginRight: 15}} onChange={(e) => this.switchOnChange(e, 'pwdResetUpdate')}/>
                        重置密码后强制用户修改密码
                    </div>
                </div>
                <div style={{borderBottom: "1px solid rgba(0, 0, 0, .15)", margin: '16px -30px'}}/>
                <Button type="primary" onClick={() => {
                    this.save()
                }} style={{alignSelf: 'center', width: '64px', height: '32px'}}>保存</Button>
            </div>
        )
    };

    // 修改
    updatePwdConfig = () => {
        let params = {
            level: this.state.currentLevel,
            pwdUpdateTime: this.state.updatePwdTime,
            firstUpdate: this.state.firstUpdate,
            outTimeUpdate: this.state.outTimeUpdate,
            pwdResetUpdate: this.state.pwdResetUpdate
        };
        let url = "/cm-sites-sys/pwdConfig/updatePwdConfig";// 地址
        this.request({
            url,
            method: 'post',
            contentType: "json",
            body: params,
            callBack: (res) => {
                if (res) {
                    message.destroy();
                    message.success("保存成功");
                    this.getPwdConfig();
                }
            },
        });
    };
    // 获取数据
    getPwdConfig = () => {
        let url = "/cm-sites-sys/pwdConfig/getPwdConfig";// 地址
        this.request({
            url,
            callBack: (res) => {
                if (res) {
                    this.setState({
                        currentLevel: res.level,
                        updatePwdTime: res.pwdUpdateTime,
                        firstUpdate: res.firstUpdate,
                        outTimeUpdate: res.outTimeUpdate,
                        pwdResetUpdate: res.pwdResetUpdate,
                    });
                    if (res.level == "0") {
                        this.setState({
                            updatePwdTime: ""
                        })
                    }
                }
            }
        });
    };
}
PasswordConfiguration.defaultProps = {};
PasswordConfiguration.propTypes = {};